export const GET_FIRMS = "GET_FIRMS";
export const GET_FIRMS_START = "GET_FIRMS_START";
export const GET_FIRMS_FAILED = "GET_FIRMS_FAILED";
